import lottie from "lottie-web/build/player/lottie_light";

export default (el, id) => {
  lottie.loadAnimation({
    container: el,
    renderer: "svg",
    loop: true,
    autoplay: true,
    path: `https://static.blinkist.com/animations/${id}.json`
  });
};
